module.exports = __webpack_public_path__ + "files/e62b81b22e18d53369520982eaf6246a.png";